module.exports = __webpack_public_path__ + "media/mountain.f866cb25.jpg";